/**
 * 动作
 */
class Action {

    constructor(option) {
        this._item = option.item;
        this._x = option.x;
        this._y = option.y;
        this.w = option.w;
        this.h = option.h;
        this.color = option.color;
        this.status = "";
        this.index = option.index;
        this.MS_PER_PX = option.MS_PER_PX;
        this.left = option.left;
    }

    get name() {
        return this._item.name;
    }

    set name(val) {
        this._item.name = val;
    }

    get x() {
        return this._x
    }

    set x(val) {
        this._x = val
    }

    get y() {
        return this._y;
    }

    get beginTime() {
        return this.MS_PER_PX * (this._x - this.left)
    }

    get endTime() {
        return this.beginTime + this.MS_PER_PX * this.w;
    }

    get item() {
        return this._item;
    }

    set item(val) {
        this._item = val;
    }

}

export default Action;